import { defineStore } from "pinia";

export const useAdditionalFieldStore = defineStore('additionalField', {
    state: () => ({
        additionalField: {},
        additionalFields: [],
    }),
    actions: {
        setAdditionalField(additionalField) {
            this.additionalField = additionalField
        },
        setAdditionalFields(additionalFields) {
            this.additionalFields = additionalFields
        },
        addAdditionalField(additionalField) {
            this.additionalFields.unshift(additionalField)
        },
        updateAdditionalField(additionalField) {
            let index = this.additionalFields.findIndex(cl => cl.id === additionalField.id)
            this.additionalFields.splice(index, 1, additionalField)
        },
        deleteAdditionalField(additionalField) {
            let index = this.additionalFields.findIndex(cl => cl.id === additionalField.id)
            this.additionalFields.splice(index, 1)
        },
    },
});